import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetDetailShiftResponse,
    ParamsGetDetailShift,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    params: ParamsGetDetailShift,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/shift-detail`,
        query: {
            shiftId: params.shiftId,
        },
    });
    const { data } = await axios.get<GetDetailShiftResponse>(apiUrl);
    return data.data;
};

export default function useDetailInvoice(
    params: ParamsGetDetailShift,
     options?: { enabled?: boolean }
) {
    return useQuery<GetDetailShiftResponse["data"]>(
        ["detailShift",params],
        () => handleRequest(params),
        // { enabled: !!params.shiftId },
        { 
            enabled: options?.enabled ?? !!params.shiftId,
        }
    );
}
